import { INewsAndInsightsListing } from '@models/INewsAndInsightsListing';
import ArticleListing from '@molecules/ArticleListing/ArticleListing';

const NewsAndInsightsListing = (props: INewsAndInsightsListing) => (
  <ArticleListing
    {...props}
    pageSize={12}
    pageLinkId={props.pageLinkId}
    loadingLabel={props.loadMoreLabel}
    infiniteLoadLabel={props.loadMoreLabel}
    language=""
    filters={props.filters.map((filter) => ({ label: filter, id: filter }))}
    showListingCardWhenFiltered
    smallTitle
  />
);

export default NewsAndInsightsListing;
